export enum Theme {
  Background = '#0d1117',
  Foreground = '#161b22',
  PrimaryContent = '#c6cdd5',
  SecondaryContent = '#899d9b',
  TertiaryContent = '#21262d',
  White = '#ecf2f8',

  Danger = '#fa7970',
  Tertiary = '#faa356',
  Special = '#7ce38b',
  Highlight = '#a2d2fb',
  Secondary = '#77bdfb',
  Primary = '#cea5fb',

  BorderRadius = 12,
}
